import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';

import ReportsPage from './ReportsPage';
import FuelOrdersPage from './FuelOrders/FuelOrdersPage';
import FuelTrucksPage from './FuelTrucks/FuelTrucksPage';
import MonthlyOilPage from './MonthlyOil/MonthlyOilPage';
import CustomerOrdersPage from './CustomerOrders/CustomerOrdersPage';

import CurrentFBO from '../../Services/CurrentFBO';
import CustomerOrdersSelectionPage from './CustomerOrders/CustomerOrdersSelectionPage';


const FuelFarm = ({ match }) => (
  <div>
    <Switch>
      <Route path={`${match.url}/fuelOrders`} render={() => (<FuelOrdersPage fboId={CurrentFBO.getId()} />)} />
      <Route path={`${match.url}/fuelTrucks`} render={() => (<FuelTrucksPage fboId={CurrentFBO.getId()} />)} />
      <Route path={`${match.url}/monthlyOil`} render={() => (<MonthlyOilPage fboId={CurrentFBO.getId()} />)} />
      <Route path={`${match.url}/customer/:tailNumber`} render={props => (<CustomerOrdersPage fboId={CurrentFBO.getId()} {...props} />)} />
      <Route path={`${match.url}/customer`} render={props => (<CustomerOrdersSelectionPage {...props} />)} />
      <Route exect path={`${match.url}`} render={() => (<ReportsPage fboId={CurrentFBO.getId()} />)} />
    </Switch>
  </div>
);

export default FuelFarm;



// WEBPACK FOOTER //
// ./src/Containers/Reports/ReportRoutes.js